/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Guide_Restricted_AccessInputs */

const en_knp_guide_restricted_access = /** @type {(inputs: Knp_Guide_Restricted_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Restricted Access`)
};

const fr_knp_guide_restricted_access = /** @type {(inputs: Knp_Guide_Restricted_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accès restreint`)
};

const de_knp_guide_restricted_access = /** @type {(inputs: Knp_Guide_Restricted_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beschränkter Zugriff`)
};

const it_knp_guide_restricted_access = /** @type {(inputs: Knp_Guide_Restricted_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accesso limitato`)
};

const ru_knp_guide_restricted_access = /** @type {(inputs: Knp_Guide_Restricted_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ограниченный доступ`)
};

const es_knp_guide_restricted_access = /** @type {(inputs: Knp_Guide_Restricted_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acceso restringido`)
};

const zh_cn2_knp_guide_restricted_access = /** @type {(inputs: Knp_Guide_Restricted_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`受限访问`)
};

const ja_knp_guide_restricted_access = /** @type {(inputs: Knp_Guide_Restricted_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アクセス制限`)
};

const hi_knp_guide_restricted_access = /** @type {(inputs: Knp_Guide_Restricted_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रतिबंधित पहुंच`)
};

const pt_pt2_knp_guide_restricted_access = /** @type {(inputs: Knp_Guide_Restricted_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acesso restrito`)
};

/**
* | output |
* | --- |
* | "Restricted Access" |
*
* @param {Knp_Guide_Restricted_AccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_guide_restricted_access = /** @type {((inputs?: Knp_Guide_Restricted_AccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Guide_Restricted_AccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_knp_guide_restricted_access(inputs)
	if (locale === "de") return de_knp_guide_restricted_access(inputs)
	if (locale === "it") return it_knp_guide_restricted_access(inputs)
	if (locale === "ru") return ru_knp_guide_restricted_access(inputs)
	if (locale === "es") return es_knp_guide_restricted_access(inputs)
	if (locale === "zh-CN") return zh_cn2_knp_guide_restricted_access(inputs)
	if (locale === "ja") return ja_knp_guide_restricted_access(inputs)
	if (locale === "hi") return hi_knp_guide_restricted_access(inputs)
	if (locale === "pt-PT") return pt_pt2_knp_guide_restricted_access(inputs)
	return en_knp_guide_restricted_access(inputs)
});